export var ShirtSize;
(function (ShirtSize) {
    ShirtSize["Small"] = "S";
    ShirtSize["Medium"] = "M";
    ShirtSize["Large"] = "L";
    ShirtSize["XLarge"] = "XL";
    ShirtSize["XXLarge"] = "XXL";
})(ShirtSize || (ShirtSize = {}));
